exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__SuggestField__root {\n  position: relative;\n  display: block;\n}\n\n.DS__SuggestField__open {\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  opacity: 0;\n}\n\n.DS__SuggestField__popup_open {\n  border-radius: 8px 8px 0 0;\n}\n", ""]);

// exports
exports.locals = {
	"root": "DS__SuggestField__root",
	"open": "DS__SuggestField__open",
	"popup_open": "DS__SuggestField__popup_open"
};